import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import s from './RowWrapper.scss';
var RowWrapper = React.forwardRef(function (_a, innerRef) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ ref: innerRef, className: classnames(s['strip'], className) }, props)));
});
RowWrapper.displayName = 'RowWrapper';
export default RowWrapper;
//# sourceMappingURL=RowWrapper.js.map